import React from 'react';
import cranes_ic from "../../assets/cranes.png";
import hydro_ic from "../../assets/hydro.png";
import knight_ic from "../../assets/knight.png";
import smart_ic from "../../assets/smart.png";
import summit_ic from "../../assets/summit.png";

const SocialProof = () => {
  const companies = [
    { name: '21 Knights', logo: knight_ic },
    { name: 'Smart Constructions', logo: smart_ic },
    { name: 'Summit Partners', logo: summit_ic },
    { name: '8Cranes', logo: cranes_ic },
    { name: 'HydroSprings Engineers', logo: hydro_ic },
  ];

  return (
    <div className="social-proof">
      <div>
        <h2>Trusted by Top-global construction companies</h2>
        <div className="companies-list">
          {companies.map((company, index) => (
            <div key={index} className="company-item">
              <img src={company.logo} alt={company.name} />
              {/* <span>{company.name}</span> */}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default SocialProof;